module.exports = __webpack_public_path__ + "img/time_limit_ico.16a86cea.svg";